const noop = ()=>undefined;
export default noop;

//# sourceMappingURL=noop.js.map